// Archivo: CsvPreview.jsx

import React from "react";
import {
  Alert,
  Box,
  Button,
  Paper,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Stack,
} from "@mui/material";

const CsvPreview = ({ file, preview, onCancel, onImport }) => {
  const withoutDocument = preview.filter((row) => !String(row.document_number ?? "").trim()).length;
  const withoutDocumentOrPhone = preview.filter(
    (row) => !String(row.document_number ?? "").trim() && !String(row.cellphone_number ?? "").trim(),
  ).length;
  const seenNames = new Set();
  const repeatedNamesWithoutIdentifiers = preview.reduce((count, row) => {
    if (String(row.document_number ?? "").trim() || String(row.cellphone_number ?? "").trim()) return count;

    const name = [row.first_name, row.last_name]
      .map((part) => String(part ?? "").trim())
      .filter(Boolean)
      .join(" ")
      .replace(/\s+/g, " ")
      .toLowerCase();

    if (!name) return count;
    if (seenNames.has(name)) return count + 1;

    seenNames.add(name);
    return count;
  }, 0);

  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <Box mb={2} display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
        <Typography variant="h6">Vista previa del archivo</Typography>
        <Stack direction="row" spacing={2} alignItems="center">
          <Typography variant="body2">{file?.name}</Typography>
          <Button variant="outlined" color="secondary" onClick={onCancel}>
            Cancelar
          </Button>
        </Stack>
      </Box>

      {withoutDocument > 0 && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          Hay {withoutDocument} {withoutDocument === 1 ? "miembro" : "miembros"} sin número de documento. Se
          pueden importar, pero sin documento no se vinculan cuentas automáticamente.
          {withoutDocumentOrPhone > 0 && (
            <>
              {" "}
              {withoutDocumentOrPhone}{" "}
              {withoutDocumentOrPhone === 1
                ? "fila tampoco tiene teléfono."
                : "filas tampoco tienen teléfono."}{" "}
              Sin ambos datos, los nombres iguales en esta organización se consideran el mismo miembro y se omiten
              las repeticiones. Si son personas distintas, agregá documento o teléfono.
              {repeatedNamesWithoutIdentifiers > 0 && (
                <>
                  {" "}
                  En este archivo hay {repeatedNamesWithoutIdentifiers}{" "}
                  {repeatedNamesWithoutIdentifiers === 1
                    ? "fila sin identificadores que repite un nombre."
                    : "filas sin identificadores que repiten un nombre."}
                </>
              )}
            </>
          )}
        </Alert>
      )}

      <TableContainer sx={{ maxHeight: 300 }}>
        <Table size="small" stickyHeader>
          <TableHead sx={{ backgroundColor: "grey.100" }}>
            <TableRow>
              {Object.keys(preview[0] || {}).map((header) => (
                <TableCell key={header} sx={{ fontWeight: 600 }}>
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {preview.slice(0, 5).map((row, idx) => (
              <TableRow key={idx}>
                {Object.values(row).map((cell, i) => (
                  <TableCell key={i}>{cell}</TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box mt={2} display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
        <Typography variant="body2">Mostrando las primeras {Math.min(5, preview.length)} filas</Typography>
        <Button variant="contained" color="primary" onClick={onImport}>
          Subir archivo
        </Button>
      </Box>
    </Paper>
  );
};

export default CsvPreview;
